import * as React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./screens.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import configureStore from "./store";
// Base reset only; full Bootstrap is imported by the lazy pages that use its classes/components
import 'bootstrap/dist/css/bootstrap-reboot.min.css';
const rootElement = document.getElementById("root");

ReactDOM.render(

    <Provider store={configureStore()}>
        <App />
    </Provider>,
    rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
